module.exports = __webpack_public_path__ + "media/homepage/FAFSA-available-annually-bbc4bd17.webp";